// Comprehensive list of academic majors
export const majors = [
  // Arts & Humanities
  "Anthropology",
  "Archaeology",
  "Architecture",
  "Art History",
  "Classical Studies",
  "Communication Studies",
  "Comparative Literature",
  "Creative Writing",
  "Criminal Justice",
  "Dance",
  "Digital Media",
  "East Asian Studies",
  "English",
  "English Literature",
  "Ethics",
  "Ethnic Studies",
  "European Studies",
  "Film Studies",
  "Fine Arts",
  "Foreign Languages",
  "French",
  "Gender Studies",
  "Geography",
  "German",
  "Graphic Design",
  "History",
  "Human Rights",
  "Humanities",
  "Interior Design",
  "International Relations",
  "Italian",
  "Japanese",
  "Jewish Studies",
  "Journalism",
  "Korean",
  "Latin American Studies",
  "Liberal Arts",
  "Linguistics",
  "Literature",
  "Media Studies",
  "Medieval Studies",
  "Middle Eastern Studies",
  "Music",
  "Music Performance",
  "Music Theory",
  "Philosophy",
  "Photography",
  "Political Science",
  "Portuguese",
  "Psychology",
  "Public Administration",
  "Public Policy",
  "Public Relations",
  "Religious Studies",
  "Russian",
  "Scandinavian Studies",
  "Sociology",
  "Spanish",
  "Studio Art",
  "Theater",
  "Theology",
  "Urban Planning",
  "Visual Arts",
  "Women's Studies",
  "Writing",

  // Business & Economics
  "Accounting",
  "Actuarial Science",
  "Advertising",
  "Agricultural Economics",
  "Banking",
  "Business Administration",
  "Business Analytics",
  "Business Economics",
  "Business Management",
  "Commerce",
  "Consumer Economics",
  "Corporate Finance",
  "Digital Marketing",
  "E-Commerce",
  "Economics",
  "Entrepreneurship",
  "Finance",
  "Financial Economics",
  "Financial Engineering",
  "Financial Management",
  "Financial Mathematics",
  "Financial Planning",
  "Hospitality Management",
  "Human Resource Management",
  "Industrial Economics",
  "Information Systems",
  "Insurance",
  "International Business",
  "International Economics",
  "International Finance",
  "Investment Management",
  "Labor Economics",
  "Logistics",
  "Management",
  "Management Information Systems",
  "Marketing",
  "Operations Management",
  "Organizational Leadership",
  "Project Management",
  "Public Finance",
  "Real Estate",
  "Risk Management",
  "Sports Management",
  "Supply Chain Management",
  "Taxation",
  "Tourism Management",

  // Science & Mathematics
  "Actuarial Mathematics",
  "Aerospace Engineering",
  "Agricultural Science",
  "Applied Mathematics",
  "Applied Physics",
  "Astronomy",
  "Astrophysics",
  "Atmospheric Science",
  "Biochemistry",
  "Bioinformatics",
  "Biology",
  "Biomedical Engineering",
  "Biophysics",
  "Biotechnology",
  "Botany",
  "Chemical Engineering",
  "Chemistry",
  "Civil Engineering",
  "Cognitive Science",
  "Computational Biology",
  "Computer Engineering",
  "Computer Science",
  "Conservation Biology",
  "Data Science",
  "Earth Science",
  "Ecology",
  "Electrical Engineering",
  "Engineering",
  "Engineering Physics",
  "Environmental Engineering",
  "Environmental Science",
  "Food Science",
  "Forestry",
  "Genetics",
  "Geology",
  "Geophysics",
  "Industrial Engineering",
  "Information Technology",
  "Marine Biology",
  "Materials Science",
  "Mathematics",
  "Mechanical Engineering",
  "Meteorology",
  "Microbiology",
  "Molecular Biology",
  "Nanotechnology",
  "Neuroscience",
  "Nuclear Engineering",
  "Oceanography",
  "Petroleum Engineering",
  "Pharmaceutical Sciences",
  "Physics",
  "Planetary Science",
  "Quantum Physics",
  "Robotics",
  "Software Engineering",
  "Statistics",
  "Systems Engineering",
  "Wildlife Biology",
  "Zoology",

  // Health & Medicine
  "Anatomy",
  "Anesthesiology",
  "Audiology",
  "Biomedical Sciences",
  "Cardiology",
  "Clinical Psychology",
  "Dental Hygiene",
  "Dentistry",
  "Dermatology",
  "Dietetics",
  "Emergency Medicine",
  "Endocrinology",
  "Epidemiology",
  "Exercise Science",
  "Gastroenterology",
  "Gerontology",
  "Health Administration",
  "Health Education",
  "Health Informatics",
  "Health Science",
  "Hematology",
  "Immunology",
  "Kinesiology",
  "Medical Laboratory Science",
  "Medicine",
  "Nephrology",
  "Neurology",
  "Nursing",
  "Nutrition",
  "Obstetrics",
  "Occupational Therapy",
  "Oncology",
  "Ophthalmology",
  "Optometry",
  "Orthodontics",
  "Orthopedics",
  "Pathology",
  "Pediatrics",
  "Pharmacy",
  "Physical Therapy",
  "Physician Assistant Studies",
  "Physiology",
  "Podiatry",
  "Psychiatry",
  "Public Health",
  "Radiology",
  "Rehabilitation Sciences",
  "Respiratory Therapy",
  "Speech-Language Pathology",
  "Sports Medicine",
  "Surgery",
  "Toxicology",
  "Veterinary Medicine",
  "Virology",

  // Education
  "Adult Education",
  "Art Education",
  "Bilingual Education",
  "Child Development",
  "Counseling",
  "Curriculum and Instruction",
  "Early Childhood Education",
  "Educational Administration",
  "Educational Leadership",
  "Educational Psychology",
  "Educational Technology",
  "Elementary Education",
  "English as a Second Language",
  "Gifted Education",
  "Higher Education",
  "Instructional Design",
  "Language Education",
  "Literacy",
  "Mathematics Education",
  "Music Education",
  "Physical Education",
  "School Counseling",
  "School Psychology",
  "Science Education",
  "Secondary Education",
  "Special Education",
  "Teacher Education",
  "TESOL (Teaching English to Speakers of Other Languages)",

  // Social Sciences
  "African American Studies",
  "African Studies",
  "American Studies",
  "Asian American Studies",
  "Asian Studies",
  "Behavioral Science",
  "Canadian Studies",
  "Chicano Studies",
  "Child and Family Studies",
  "Community Development",
  "Conflict Resolution",
  "Criminology",
  "Demography",
  "Development Studies",
  "Disability Studies",
  "Environmental Policy",
  "Environmental Studies",
  "European Studies",
  "Forensic Science",
  "Gerontology",
  "Global Studies",
  "Human Development",
  "Human Geography",
  "Human Services",
  "Indigenous Studies",
  "International Development",
  "International Studies",
  "Labor Studies",
  "Latin American Studies",
  "Legal Studies",
  "LGBTQ Studies",
  "Military Science",
  "Peace Studies",
  "Policy Analysis",
  "Political Economy",
  "Population Studies",
  "Poverty Studies",
  "Rural Studies",
  "Security Studies",
  "Social Justice",
  "Social Work",
  "Sustainable Development",
  "Urban Studies",
  "Youth Studies",

  // Interdisciplinary Studies
  "Artificial Intelligence",
  "Bioethics",
  "Bioinformatics",
  "Biomechanics",
  "Biotechnology",
  "Blockchain Technology",
  "Computational Linguistics",
  "Cybersecurity",
  "Data Analytics",
  "Digital Humanities",
  "Environmental Design",
  "Food Studies",
  "Forensic Accounting",
  "Game Design",
  "Geographic Information Science",
  "Health Economics",
  "Human-Computer Interaction",
  "Information Science",
  "Integrated Science",
  "Interdisciplinary Studies",
  "Machine Learning",
  "Medical Humanities",
  "Neurobiology",
  "Psycholinguistics",
  "Science and Technology Studies",
  "Social Computing",
  "Sustainable Energy",
  "Systems Biology",
  "Urban Informatics",
  "User Experience Design",

  // Additional Fields
  "Agriculture",
  "Animal Science",
  "Aviation",
  "Brewing Science",
  "Cannabis Studies",
  "Cosmetology",
  "Culinary Arts",
  "Dairy Science",
  "Enology (Wine Studies)",
  "Fashion Design",
  "Fashion Merchandising",
  "Fermentation Sciences",
  "Fisheries Science",
  "Floral Design",
  "Food Service Management",
  "Forestry Management",
  "Game Development",
  "Horticulture",
  "Hotel Management",
  "Industrial Design",
  "Landscape Architecture",
  "Maritime Studies",
  "Meat Science",
  "Metallurgical Engineering",
  "Mining Engineering",
  "Musical Theatre",
  "Nuclear Science",
  "Packaging Science",
  "Paleontology",
  "Paralegal Studies",
  "Poultry Science",
  "Range Management",
  "Recreation Management",
  "Resort Management",
  "Retail Management",
  "Sound Engineering",
  "Sports Science",
  "Textile Science",
  "Turfgrass Science",
  "Viticulture",
  "Water Resources",
  "Web Development",
  "Wildlife Management",
  "Wood Science",
];
